<template>
    <div class="ObjectDescriptionParams">
        <div class="ObjectDescriptionParams__item" v-for="({title, value}, index) of params" :key="index">
            <div class="ObjectDescriptionParams__title">{{title}}</div>
            <div class="ObjectDescriptionParams__value">{{getValueString(value)}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ObjectDescriptionParams",
    /*props: {
        params: {
            type: Array,
            default: () => list
            /!*default: () => [
                {
                    title: 'Этажность',
                    value: 2
                },
                {
                    title: 'Санузлов',
                    value: 3
                },
                {
                    title: 'СПА',
                    value: true
                },
                {
                    title: 'Охрана',
                    value: true
                },
                {
                    title: 'Водоснабжение',
                    value: 'Скважна'
                },
                {
                    title: 'Спален',
                    value: 4
                },
                {
                    title: 'Бассейн',
                    value: true
                },
                {
                    title: 'Квартира персонала',
                    value: false
                },
                {
                    title: 'Газоснабжение',
                    value: 'Магистральный газ'
                },
                {
                    title: 'Электричество',
                    value: '10 кВт'
                },
            ]*!/
        }
    },*/
    /*data: () => ({
        /!*list: [
            {
                name: 'Объекты',
                text: 100,
                param: null,
                icon: HomeIcon,
            },
            {
                name: 'Был показ',
                text: 11,
                param: filterTypes.shown,
                icon: EyeIcon,
            },
            {
                name: 'Не понравились',
                text: 999,
                icon: LikeIcon,
                param: filterTypes.disliked
            },
            {
                name: 'Понравились',
                text: 11,
                param: 'liked',
                icon: DislikeIcon,
                secondary: filterTypes.liked
            },

        ],*!/
        //activeItem: 'all',
    }),*/
    methods: {
        getValueString(value) {
            if (value === '1') return "Да";
            if (value === '0') return "Нет";
            return value.toString();
        },
    },
    computed: {
        params: function() {
            let obj = this.$store.state.objects.filter(object => object.id === this.$route.params.id);
            return obj[0].full_params.house_data;
        }
    }
}
</script>

<style lang="scss">
.ObjectDescriptionParams {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 16px;
  padding-right: 20%;

  @include tablet {
    padding-right: 0;
  }

  @include mobile {
    grid-template-columns: repeat(2, 1fr);
  }


  &__item {

  }

  &__title {
    margin-bottom: 5px;
    color: $gray;
  }

  &__value {

  }
}
</style>